import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import Layout from '@/components/layout/Layout.vue';
import Index from '@/views/Index.vue';
import NewsList from '@/views/NewsList.vue';
import NewsDetail from '@/views/NewsDetail.vue';
import NoticeList from '@/views/NoticeList.vue';
import NoticeDetail from '@/views/NoticeDetail.vue';
import GroupEvents from '@/views/about/GroupEvents.vue';
import About from '@/views/about/About.vue';
import Executives from '@/views/about/Executives.vue';
import ExplosivesBusiness from '@/views/business/ExplosivesBusiness.vue';
import MiningBusiness from '@/views/business/MiningBusiness.vue';
import MiningBusinessConstruction from '@/views/business/MiningExplore.vue';
import Honors from '@/views/about/Honors.vue';
import Video from '@/views/about/Video.vue';
import Contact from '@/views/contact/Contact.vue';

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    component: Layout,
    children: [
      {
        path: '',
        name: 'Home',
        component: Index
      },
      { path: 'news', component: NewsList },
      { path: 'news/:id', component: NewsDetail, props: true },
      { path: 'notice', component: NoticeList },
      { path: 'notice/:id', component: NoticeDetail, props: true },
      { path: 'about/group_events', component: GroupEvents },
      { path: 'about', component: About },
      { path: 'about/executives', component: Executives },
      { path: 'about/honors', component: Honors },
      { path: 'about/video', component: Video },
      { path: 'business/mining', component: MiningBusiness },
      { path: 'business/mine-construction', component: MiningBusinessConstruction },
      { path: 'business/explosives', component: ExplosivesBusiness },
      { path: 'contact', component: Contact },
    ]
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = `${to.meta.title as string} - 比优集团`;
  }
  next();
});

export default router
